
import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";

import { formatDate, parseDate } from "../ProgrammationManager/Helpers/dateFormatter";

import { useDatePicker } from "@/Hooks/UseDatePicker";
import useTranslation from "@/Hooks/UseTranslation";

import Button from '@/Components/Button/Button'

import "./ModalDatePicker.scss";

const ModalDatePicker = () => {

  const { t } = useTranslation()

  const {
    show,
    mode,
    date,
    projectStartDate,
    projectEndDate,
    nonWorkingDays,
    onChange,
    hideDatePicker,
  } = useDatePicker();

  const [draftValue, setDraftValue] = useState<Date | null>(null)

  const projStartDate = parseDate(projectStartDate) ?? new Date()
  const projEndDate = parseDate(projectEndDate) ?? new Date()

  const nonWorkingSet = useMemo(() => new Set(nonWorkingDays || []), [nonWorkingDays])

  useEffect(() => {

    const dateMoment = moment(date, 'YYYY-MM-DD')

    setDraftValue(dateMoment.toDate())
  }, [date])

  const handleDateChange = (value: Date | null) => {
    setDraftValue(value)

    if (onChange && value) {
      onChange(formatDate(value))
    }

    hideDatePicker()
  }

  return (
    <Modal
      show={show && mode === 'day'}
      className="modal-date-picker"
      backdropClassName='modal-date-picker-backdrop'
      centered
      onHide={hideDatePicker}
    >
      <Modal.Body>
        <div className="datepicker-container">
          <DatePicker
            inline
            filterDate={(date) => !nonWorkingSet.has(formatDate(date))}
            wrapperClassName="input-date__wrapper"
            calendarClassName="input-date__calendar"
            className="input-date__root"
            startDate={draftValue}
            endDate={draftValue}
            minDate={projStartDate}
            maxDate={projEndDate}
            openToDate={draftValue ?? projStartDate}
            onChange={handleDateChange}
            renderCustomHeader={({
              monthDate,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => {
              const prevDisabled =
                prevMonthButtonDisabled ||
                monthDate <= projStartDate

              const nextDisabled =
                nextMonthButtonDisabled ||
                monthDate >= projEndDate

              return (
                <div className="d-flex justify-content-between align-items-center px-2">
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={decreaseMonth}
                    disabled={prevDisabled}
                  >
                    ‹
                  </Button>

                  <span className="font-weight-bold">
                    {monthDate.toLocaleString('es-PE', {
                      month: 'long',
                      year: 'numeric',
                    })}
                  </span>

                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={increaseMonth}
                    disabled={nextDisabled}
                  >
                    ›
                  </Button>
                </div>
              )
            }}
          />
          <div className="buttons">
            <Button
              variant="primary"
              onClick={hideDatePicker}
            >
              {t('DATEPICKER:CancelButton')}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalDatePicker;
